export const MAP_ENTITY_DRAWER_WIDTH = 532;

export const MAP_ENTITY_DRAWER_MIN_SNAP_PCT = 0.207;
export const MAP_ENTITY_DRAWER_MAX_SNAP_PCT = 0.8;

export const CAMERA_DRAWER_MIN_SNAP_PCT = 0.1;

export const MAP_ENTITY_DRAWER_MOBILE_DRAWER_ID =
  'map-entity-drawer-bottom-sheet';
